import { GenericCollectionFactory } from "../_generics";

export const EverouDevelopersStore = GenericCollectionFactory("DEVELOPERS", "uid");